import { QUERY_KEY, MUTATION_KEY } from "constants/globalConstants";
import ApiService from "apiService";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useEditEntity = (setShowEditForm, id) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.EDIT_ENTITY],
    (data) => ApiService.editEntity(data, id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY.GET_ENTITY_LIST);
        setShowEditForm(false)
        toast.success('Entity edited successfully')
      },
      onError: (error) => {
        toast.error(error.response.data.message)
    },
    }
  );
};

export default useEditEntity